import { render, staticRenderFns } from "./content-wrapper.vue?vue&type=template&id=4d65b1e2"
import script from "./content-wrapper.vue?vue&type=script&lang=ts"
export * from "./content-wrapper.vue?vue&type=script&lang=ts"
import style0 from "./content-wrapper.vue?vue&type=style&index=0&id=4d65b1e2&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d65b1e2')) {
      api.createRecord('4d65b1e2', component.options)
    } else {
      api.reload('4d65b1e2', component.options)
    }
    module.hot.accept("./content-wrapper.vue?vue&type=template&id=4d65b1e2", function () {
      api.rerender('4d65b1e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content-wrapper/content-wrapper.vue"
export default component.exports